import MsftSSO from './MsftSSO'

export default MsftSSO;